module.exports = __webpack_public_path__ + "static/assets/183c74aa61df92918da282d92d60bc24.svg";